import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
    import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, changeDateFormat,handleUserLevelAccessPermissions, getAllYears, validateRoles, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { compilationExcelReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { format } from 'date-fns';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';

const CompilationReport = () => {
     const [years, setYears] = useState([]);
    const [months, setMonth] = useState([]);
    const [yearName, setYearName] = useState(new Date().getFullYear()); // Set current year as default
    const [startDate, setStartDate] = useState();
    const [monthName, setMonthName] = useState('');
    const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });

    const token = useContext(MyContextProvider).token;
    // const decode_token = jwtDecode(token)
    const decode_token = getUserClaimsForUi();
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();
    const [dateSelectedError, setDateSelectedError] = useState(false);




useEffect(() => {

    const getMonthsList = (e) => {
        showLoading(true)
        axios
            .get(`${API_URL}api/graph/getMonths/2019`, config)
            .then((res) => {
                let monthDataResponse = res.data;
                if (monthDataResponse.status) {
                    setMonth(monthDataResponse.data);
                    showLoading(false)
                }
            })
            .catch((err) => {
                console.error(err);
                showLoading(false);
            });
    }

    const getYearList = () => {
        const startYear = 2014; // Starting year
        const endYear = new Date().getFullYear(); // Ending year

        const yearsArray = [];
        for (let year = startYear; year <= endYear; year++) {
            yearsArray.push(year);
        }

        setYears(yearsArray);
    };

    getYearList();
    getMonthsList();

}, []);




const storedLanguage = localStorage.getItem('language');
const currentMonth = new Date().getMonth();
const currentYear = new Date().getFullYear();




//Ger Report Data ********************
const handleGenerateExcel = () => {

    if (!startDate) {
        setDateSelectedError(true);
        toast.error("Please select a date to generate the report.", messages.COLOR_RED);
        return;
    }
  // Format the selected date correctly
    const formattedDate = startDate ? format(new Date(startDate), 'dd-MM-yyyy') : '';
    const postData = {
        fromDate: formattedDate,
    };

 showLoading(true)
 
    axios
        .post(`${API_URL}api/price/compilationReport`, postData, config)
        .then((response) => {
            const reportData = response.data;
            if (reportData.status) {
               
              let allData = reportData.data.GroupCodes;
                downloadReport(allData,startDate,reportData.data.columnName,reportData.data.avgValues)
            } else {
               toast.error('Data is not found', messages.COLOR_RED);
           }
       })
        .catch((error) => {
          console.error('API Error', error);
        })
        .finally(() => {
          showLoading(false)
        })

};

const formatGrossValue = (value) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(2);
};

const formatDateData = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };

    return date.toLocaleString('en-GB', options).replace(/ /g, '-');
  };


const downloadReport=(allData,startDate,columnName,avgValues)=>{
  
   const extractedData = allData.map((item,index) => ([
    (index===0)?formatDateData(item.PRICE_DATE):'',
    item.DISTRICT_NAME_HINDI,
    formatGrossValue(item['PRICE_WHEAT_(AVERAGE)']),
    formatGrossValue(item['PRICE_MAIDA_(LOCAL)']),
    formatGrossValue(item['PRICE_GRAM_(LOCAL_QUALITY)']),
    formatGrossValue(item['PRICE_GRAM_FLOUR_(AVERAGE)']),
    formatGrossValue(item['PRICE_RICE_(MEDIUM_SIZE)']),
    formatGrossValue(item['PRICE_MAIZE_(RED_AND_YELLOW)']),
    formatGrossValue(item['PRICE_ARHAR_DAL_(DESI_INFERIOR_QUALITY)']),
    formatGrossValue(item['PRICE_MOONG_DAL_(LOCAL_PEELED)']),
    formatGrossValue(item['PRICE_MOONG_DAL_(UNPEELED_AVERAGE)']),
    formatGrossValue(item['PRICE_URD_DAL_(AVERAGE_PEELED)']),
    formatGrossValue(item['PRICE_URD_DAL_(UNPEELED_AVERAGE)']),
    formatGrossValue(item['PRICE_ONION_(LOCAL_DRY)']),
    formatGrossValue(item['PRICE_POTATO_(DESI_AVERAGE_MEDIUM_SIZE)']),
    formatGrossValue(item['PRICE_MUSTARD_OIL_(LOCAL_MILL)']),
    formatGrossValue(item['PRICE_MEAT_(GOAT)']),
    formatGrossValue(item['PRICE_FISH_(ROHU_AVERAGE_SIZE)']),
    formatGrossValue(item['PRICE_FISH_(PADHIN_AVERAGE_SIZE)']),
    formatGrossValue(item['PRICE_EGG_(HEN_FARM)']),
    formatGrossValue(item['PRICE_JAGGERY_(DESI)']),
    formatGrossValue(item['PRICE_SUGAR_(GRANULAR_MEDIUM_SIZE)']),
    formatGrossValue(item['PRICE_SALT_(POWDER)']),
    formatGrossValue(item['PRICE_RED_CHILI_(LOCAL)']),
    formatGrossValue(item['PRICE_DHOTI_FEMALE_(MEDIUM__POWERLOOM)']),
    formatGrossValue(item['PRICE_LATTHA_(POWERLOOM_MEDUIM_QUALITY)']),
    formatGrossValue(item['PRICE_MARKIN_(MEDIUM)']),
    formatGrossValue(item['PRICE_COTTON_(DESI)']),
    formatGrossValue(item['PRICE_YARN_(STANIL_22_COUNT_NUMBER)']),
    formatGrossValue(item['PRICE_VANASPATI_GHEE_(KISHTI_AND_PANGHAT)']),
    formatGrossValue(item['PRICE_SOFTCOKE_(OD_COAL)']),
    formatGrossValue(item['PRICE_KEROSENE_OIL_(WHITE)']),
    formatGrossValue(item['PRICE_MATCH_BOX_(TIKKA_AND_LOCAL)']),
    formatGrossValue(item['PRICE_DETERGENT_SOAP_(TATA_501_AND_250_GRAM)']),
    formatGrossValue(item['PRICE_BATHING_SOAP_(LIFEBOUY_50_GRAM)']),
    formatGrossValue(item['PRICE_TEA_LEAF_(BROOKBOND_AND_REDLEBEL)']),
    formatGrossValue(item['PRICE_CYCLE_TYRE_(RALSON_4PLY)']),
    formatGrossValue(item['PRICE_CYCLE_TYRE_(ROAD_STAR_99)']),
    formatGrossValue(item['PRICE_CYCLE_TUBE_(ROAD_STAR_99)']),
    formatGrossValue(item['PRICE_CYCLE_TUBE_(RALSON)']),
    formatGrossValue(item['PRICE_BABY_FOOD_(GLASCO_AND_AMUL)']),
    formatGrossValue(item['PRICE_MEDICINES_(FENOCIN)']),
    formatGrossValue(item['PRICE_MEDICINES_(ANACIN)']),
    formatGrossValue(item['PRICE_COPY_(64_PAGES_WHITE_COVER)']),
    formatGrossValue(item['PRICE_PRINTING_PAPER_(WHITE_3.2_KG)']),
    formatGrossValue(item['PRICE_ELECTRIC_BULB_(PHILIPS_40_WATT)']),
    formatGrossValue(item['PRICE_TORCH_CELL_(EVERREADY_950)']),
    formatGrossValue(item['PRICE_CEMENT_(ACC_AND_SWASTIK)']),
    formatGrossValue(item['PRICE_GHEE_(DESI)']),
    formatGrossValue(item['PRICE_STAINLESS_STEEL_UTENSILE_(THALI_24_GAGE)']),
    formatGrossValue(item['PRICE_STAINLESS_STEEL_UTENSILE_(BHAGONA_4_GAGE)']),
    formatGrossValue(item['PRICE_CORRIANDLE_(DESI)']),
    formatGrossValue(item['PRICE_TURMERIC_(WHOLE)']),
    formatGrossValue(item['PRICE_CUMINSEEDS_(WHITE_MEDIUM)']),
    formatGrossValue(item['PRICE_BLACK_CHILLI_(REAL_SIZE)']),
    formatGrossValue(item['PRICE_BREAD_(LOCAL)']),
    formatGrossValue(item['PRICE_BARLEY_(DESI)']),
    formatGrossValue(item['PRICE_JOWAR_(WHITE)']),
    formatGrossValue(item['PRICE_BRINJAL']),
    formatGrossValue(item['PRICE_CAULIFLOWER']),
    formatGrossValue(item['PRICE_CABBAGE']),
    formatGrossValue(item['PRICE_GOURD']),
    formatGrossValue(item['PRICE_PUMPKIN']),
    formatGrossValue(item['PRICE_TOMATO']),
    formatGrossValue(item['PRICE_GREENCHILLI']),
    formatGrossValue(item['PRICE_APPLE']),
    formatGrossValue(item['PRICE_BANANA_']),
    formatGrossValue(item['PRICE_PAPAYA']),
    formatGrossValue(item['PRICE_GUAVA']),
    formatGrossValue(item['PRICE_MOSAMBI']),
    formatGrossValue(item['PRICE_MANGO']),
    formatGrossValue(item['PRICE_ORANGE']),
    formatGrossValue(item['PRICE_GRAPE']),
    formatGrossValue(item['PRICE_GOLD_(STANDARD_)']),
    formatGrossValue(item['PRICE_SILVER_(READY)']),
    formatGrossValue(item['PRICE_MASOOR_DAL_(DALI)']),
    formatGrossValue(item['PRICE_POTATO_(PAHADI_AVERAGE_MEDIUM_SIZE)'])
    
    ]));
  

    const excelObjectData = {
        fileName: `Pri67InputReport_${format(new Date(startDate), 'dd-MM-yyyy')}`,
        fileType: 'xls',
        sheetName: "pri_67_input_report",
        firstRowMergeCells: "A1:H1",
        firstRowExportDate: changeDateFormat(new Date()),
        secondRowMergeCells: "A2:H2",
        secondRowText: `67 आवश्यक वस्तुओं  के फुटकर भाव (आधार वर्ष 2011-12=100)`,
        thirdRowMergeCells: "A3:H3",
        thirdRowText: `(${format(new Date(startDate), 'dd-MM-yyyy')})`,
        excelRowData: extractedData,
        headerEnglishColumns:['','',...columnName]

    };

    extractedData[extractedData.length]=['','Average',...avgValues]
 
    compilationExcelReport(excelObjectData)


}


const filterDate = (date) => {
    return date <= new Date(); // Disable dates after today
};

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.COMPILATION_REPORT : priceTitle.en.COMPILATION_REPORT }} />
                            </h4>

                            <div className="row align-items-center">
                              
                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                                    <label className="fw-bold h6"> Select Date Range	</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="DD-MM-YYYY"
                                        selected={startDate}
                                        onChange={(date) => {
                                            setStartDate(date);
                                            setDateSelectedError(false); // Clear error when date is selected
                                        }}
                                        filterDate={filterDate}  // Update startDate state on date selection
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                            <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    onChange={(e) => {
                                                        setYearName(parseInt(e.target.value)); // Update yearName when changed
                                                        changeYear(parseInt(e.target.value));
                                                    }}
                                                    value={yearName} // Update value to yearName
                                                >
                                                    <option value="" disabled>Select Year</option>
                                                    {years &&
                                                        years.map((ele, index) => (
                                                            <option key={index} value={ele}>
                                                                {ele}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    value={date.getMonth()} // Use date.getMonth() instead of monthName
                                                    onChange={(e) => {
                                                        setMonthName(e.target.value); // Update monthName when changed
                                                        changeMonth(e.target.value);
                                                    }}
                                                >
                                                    <option value="" disabled>Select Month</option>
                                                    {months &&
                                                        months
                                                        .filter((_, i) => !(currentYear === yearName && i > currentMonth))
                                                        .map((ele, i) => (
                                                            <option key={i} value={i}>
                                                                {shortMonthToFull(ele.MONTH)}
                                                            </option>
                                                        ))}
                                                </select>

                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                    {">"}
                                                </button>
                                            </div>
                                        )}
                                    />

                                </div>

                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default CompilationReport